import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
/* eslint-disable react/prop-types */
import React from 'react';
import FontAwesome from 'react-fontawesome';
import { Chip } from '@applyboard/ui-components';
import { STUDENT_RECORDS_ICON_WHITE as StudentRecordIconWhite, ICON_INTERNAL_IMPORTED as iconInternal } from "../../../../util/cdnAssets";
import { _ApplicationStatusCircle, _TabSelectoryEntryWrapper, _TabSelectorBadge } from "../styles";
import { useEventTracker } from '@applyboard/ui-utils';
var TabSelectorIcon = function TabSelectorIcon(_ref) {
  var icon = _ref.icon;
  if (!icon) return null;
  if (icon === 'student-records') {
    return /*#__PURE__*/React.createElement("img", {
      src: StudentRecordIconWhite,
      alt: icon
    });
  }
  if (icon === 'internal-icon') {
    return /*#__PURE__*/React.createElement("img", {
      src: iconInternal,
      alt: icon,
      height: "20",
      width: "20"
    });
  }
  return /*#__PURE__*/React.createElement(FontAwesome, {
    name: icon
  });
};
var TabSelectorEntry = function TabSelectorEntry(_ref2) {
  var icon = _ref2.icon,
    label = _ref2.label,
    notesLength = _ref2.notesLength,
    _onClick = _ref2.onClick,
    selected = _ref2.selected,
    showAppReqCount = _ref2.showAppReqCount,
    showActionsCount = _ref2.showActionsCount,
    appReqCount = _ref2.appReqCount,
    actionsCount = _ref2.actionsCount;
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions
    React.createElement("li", {
      "walkme-id": "applications-tab".concat(label.replace(/\s/g, '').toLowerCase()),
      "data-testid": label,
      className: "nav-item".concat(selected ? ' selected' : ''),
      onClick: function onClick() {
        trackEvent({
          event: "Single Application - Clicked ".concat(label, " Tab")
        });
        _onClick();
      }
    }, /*#__PURE__*/React.createElement(_TabSelectoryEntryWrapper, {
      className: "nav-link".concat(selected ? ' active' : '')
    }, /*#__PURE__*/React.createElement(TabSelectorIcon, {
      icon: icon
    }), /*#__PURE__*/React.createElement("span", null, label), label === 'Applicant Requirements' && showAppReqCount && appReqCount !== 0 && /*#__PURE__*/React.createElement(Chip, {
      size: "small",
      color: "negative",
      style: {
        marginLeft: '5px'
      }
    }, appReqCount), label === 'Actions' && showActionsCount && actionsCount !== 0 && /*#__PURE__*/React.createElement(Chip, {
      size: "small",
      color: "negative",
      style: {
        marginLeft: '5px'
      }
    }, actionsCount), notesLength < 0 && /*#__PURE__*/React.createElement(_TabSelectorBadge, null), notesLength > 0 && /*#__PURE__*/React.createElement(_ApplicationStatusCircle, null, notesLength)))
  );
};
export default TabSelectorEntry;